/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */

import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import Button from "@mui/material/Button";
import MDTypography from "components/MDTypography";
import { useState } from "react";
import toast from "react-hot-toast";
import { Divider, Typography } from "@mui/material";
import InputFileUpload from "./InputFile";
import { FileUploader } from "react-drag-drop-files";
import { PropaneSharp } from "@mui/icons-material";

function DocumentacionAdministrativa({ Back, Next, props = [], vista = "registrar" }) {
  // props siempre es un array (aunque esté vacío)
  const filesMap = (props ?? []).reduce((acc, item) => {
    acc[item.titulo] = item.file || null;
    return acc;
  }, {});

  const [fileActaNacimiento, setfileActaNacimiento] = useState(
    filesMap["ArchivoActaNacimiento"] ?? null
  );
  const [isValid_fileActaNacimiento, setisValid_fileActaNacimiento] = useState(false);

  const [fileCURPmenor, setfileCURPmenor] = useState(filesMap["ArchivoCurpMenor"] ?? null);
  const [isValid_fileCURPmenor, setisValid_fileCURPmenor] = useState(false);

  const [fileCURPpadre, setfileCURPpadre] = useState(filesMap["ArchivoCurpPadre"] ?? null);
  const [isValid_fileCURPpadre, setisValid_fileCURPpadre] = useState(false);

  const [fileCURPmadre, setfileCURPmadre] = useState(filesMap["ArchivoCurpMadre"] ?? null);
  const [isValid_fileCURPmadre, setisValid_fileCURPmadre] = useState(false);

  const [fileIDpadre, setfileIDpadre] = useState(filesMap["ArchivoIdentificacionPadre"] ?? null);
  const [isValid_fileIDpadre, setisValid_fileIDpadre] = useState(false);

  const [fileIDmadre, setfileIDmadre] = useState(filesMap["ArchivoIdentificacionMadre"] ?? null);
  const [isValid_fileIDmadre, setisValid_fileIDmadre] = useState(false);

  const [fileCartilla, setfileCartilla] = useState(filesMap["ArchivoCartillaVacunacion"] ?? null);
  const [isValid_fileCartilla, setisValid_fileCartilla] = useState(false);

  const [fileComprobanteDom, setfileComprobanteDom] = useState(
    filesMap["ArchivoComprobanteDomicilio"] ?? null
  );
  const [isValid_fileComprobanteDom, setisValid_fileComprobanteDom] = useState(false);

  const ValidaForm = () => {
    if (!fileActaNacimiento) {
      toast.error("Archivo Obligatorio *");
      setisValid_fileActaNacimiento(true);
      return false;
    }
    if (!fileCURPmenor) {
      toast.error("Archivo Obligatorio *");
      setisValid_fileCURPmenor(true);
      return false;
    }

    if (!fileCURPpadre && !fileCURPmadre && !fileIDpadre && !fileIDmadre) {
      toast.error("Debe subir los documentos de al menos el padre o la madre *");
      setisValid_fileCURPpadre(true);
      setisValid_fileCURPmadre(true);
      setisValid_fileIDpadre(true);
      setisValid_fileIDmadre(true);
      return null;
    }

    if (!fileCURPpadre && fileIDpadre) {
      toast.error("Archivo Obligatorio *");
      setisValid_fileCURPpadre(true);
      return false;
    }

    if (!fileCURPmadre && fileIDmadre) {
      toast.error("Archivo Obligatorio *");
      setisValid_fileCURPmadre(true);
      return false;
    }
    if (!fileIDpadre && fileCURPpadre) {
      toast.error("Archivo Obligatorio *");
      setisValid_fileIDpadre(true);
      return false;
    }
    if (!fileIDmadre && fileCURPmadre) {
      toast.error("Archivo Obligatorio *");
      setisValid_fileIDmadre(true);
      return false;
    }
    if (!fileCartilla) {
      toast.error("Archivo Obligatorio *");
      setisValid_fileCartilla(true);
      return false;
    }
    if (!fileComprobanteDom) {
      toast.error("Archivo Obligatorio *");
      setisValid_fileComprobanteDom(true);
      return false;
    }

    var files = [];

    files.push({
      titulo: "ArchivoActaNacimiento",
      file: fileActaNacimiento,
    });
    files.push({
      titulo: "ArchivoCurpMenor",
      file: fileCURPmenor,
    });
    if (fileCURPpadre) {
      files.push({
        titulo: "ArchivoCurpPadre",
        file: fileCURPpadre,
      });
    }
    if (fileCURPmadre) {
      files.push({
        titulo: "ArchivoCurpMadre",
        file: fileCURPmadre,
      });
    }
    if (fileIDpadre) {
      files.push({
        titulo: "ArchivoIdentificacionPadre",
        file: fileIDpadre,
      });
    }
    if (fileIDmadre) {
      files.push({
        titulo: "ArchivoIdentificacionMadre",
        file: fileIDmadre,
      });
    }
    files.push({
      titulo: "ArchivoCartillaVacunacion",
      file: fileCartilla,
    });
    files.push({
      titulo: "ArchivoComprobanteDomicilio",
      file: fileComprobanteDom,
    });

    Next(files);
  };

  const handleBack = () => {
    var files = [];

    files.push({
      titulo: "ArchivoActaNacimiento",
      file: fileActaNacimiento,
    });
    files.push({
      titulo: "ArchivoCurpMenor",
      file: fileCURPmenor,
    });
    files.push({
      titulo: "ArchivoCurpPadre",
      file: fileCURPpadre,
    });

    files.push({
      titulo: "ArchivoCurpMadre",
      file: fileCURPmadre,
    });

    files.push({
      titulo: "ArchivoIdentificacionPadre",
      file: fileIDpadre,
    });

    files.push({
      titulo: "ArchivoIdentificacionMadre",
      file: fileIDmadre,
    });

    files.push({
      titulo: "ArchivoCartillaVacunacion",
      file: fileCartilla,
    });
    files.push({
      titulo: "ArchivoComprobanteDomicilio",
      file: fileComprobanteDom,
    });

    Back(files);
  };

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12} md={12} lg={12}>
          <MDBox textAlign="center">
            <MDTypography variant="h5" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
              Por favor cargue todos los estudios con los que cuente el menor incluidos el Informe
              de alta hospitalaria, otros informes médicos relevantes y los relacionados a la
              sordera.
            </MDTypography>
          </MDBox>
        </Grid>
      </Grid>
      <Divider />
      <Grid container spacing={2}>
        <Grid item xs={12} md={3} lg={3}>
          <MDBox textAlign="right">
            <MDTypography
              variant="h5"
              color={isValid_fileActaNacimiento ? "error" : "white"}
              style={{ opacity: 0.7, fontSize: "0.9rem" }}
            >
              Acta de nacimiento del menor
            </MDTypography>
          </MDBox>
        </Grid>
        <Grid item xs={12} md={9} lg={9}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12} lg={12}>
              <MDBox textAlign="left">
                <InputFileUpload
                  onchangeFile={(file) => {
                    setfileActaNacimiento(file);
                    setisValid_fileActaNacimiento(false);
                  }}
                  valueF={fileActaNacimiento}
                />
                <MDTypography
                  variant="text"
                  color={isValid_fileActaNacimiento ? "error" : "white"}
                  style={{ opacity: 0.7, fontSize: 14, marginLeft: "2px" }}
                >
                  {isValid_fileActaNacimiento ? "Archivo bligatorio *" : ""}
                </MDTypography>
              </MDBox>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Divider />

      <Grid container spacing={2}>
        <Grid item xs={12} md={3} lg={3}>
          <MDBox textAlign="right">
            <MDTypography
              variant="h5"
              color={isValid_fileCURPmenor ? "error" : "white"}
              style={{ opacity: 0.7, fontSize: "0.9rem" }}
            >
              CURP del Menor
            </MDTypography>
          </MDBox>
        </Grid>
        <Grid item xs={12} md={9} lg={9}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12} lg={12}>
              <MDBox textAlign="left">
                <InputFileUpload
                  onchangeFile={(file) => {
                    setfileCURPmenor(file);
                    setisValid_fileCURPmenor(false);
                  }}
                  valueF={fileCURPmenor}
                />
                <MDTypography
                  variant="text"
                  color={isValid_fileCURPmenor ? "error" : "white"}
                  style={{ opacity: 0.7, fontSize: 14, marginLeft: "2px" }}
                >
                  {isValid_fileCURPmenor ? "Archivo bligatorio *" : ""}
                </MDTypography>
              </MDBox>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Divider />
      <Grid container spacing={2}>
        <Grid item xs={12} md={3} lg={3}>
          <MDBox textAlign="right">
            <MDTypography
              variant="h5"
              color={isValid_fileCURPpadre ? "error" : "white"}
              style={{ opacity: 0.7, fontSize: "0.9rem" }}
            >
              CURP del Padre
            </MDTypography>
          </MDBox>
        </Grid>
        <Grid item xs={12} md={9} lg={9}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12} lg={12}>
              <MDBox textAlign="left">
                <InputFileUpload
                  onchangeFile={(file) => {
                    setfileCURPpadre(file);
                    setisValid_fileCURPpadre(false);
                  }}
                  valueF={fileCURPpadre}
                />
                <MDTypography
                  variant="text"
                  color={isValid_fileCURPpadre ? "error" : "white"}
                  style={{ opacity: 0.7, fontSize: 14, marginLeft: "2px" }}
                >
                  {isValid_fileCURPpadre ? "Archivo bligatorio *" : ""}
                </MDTypography>
              </MDBox>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Divider />
      <Grid container spacing={2}>
        <Grid item xs={12} md={3} lg={3}>
          <MDBox textAlign="right">
            <MDTypography
              variant="h5"
              color={isValid_fileCURPmadre ? "error" : "white"}
              style={{ opacity: 0.7, fontSize: "0.9rem" }}
            >
              CURP de la Madre
            </MDTypography>
          </MDBox>
        </Grid>
        <Grid item xs={12} md={9} lg={9}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12} lg={12}>
              <MDBox textAlign="left">
                <InputFileUpload
                  onchangeFile={(file) => {
                    setfileCURPmadre(file);
                    setisValid_fileCURPmadre(false);
                  }}
                  valueF={fileCURPmadre}
                />
                <MDTypography
                  variant="text"
                  color={isValid_fileCURPmadre ? "error" : "white"}
                  style={{ opacity: 0.7, fontSize: 14, marginLeft: "2px" }}
                >
                  {isValid_fileCURPmadre ? "Archivo bligatorio *" : ""}
                </MDTypography>
              </MDBox>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Divider />
      <Grid container spacing={2}>
        <Grid item xs={12} md={3} lg={3}>
          <MDBox textAlign="right">
            <MDTypography
              variant="h5"
              color={isValid_fileIDpadre ? "error" : "white"}
              style={{ opacity: 0.7, fontSize: "0.9rem" }}
            >
              Identificación oficial del Padre
            </MDTypography>
          </MDBox>
        </Grid>
        <Grid item xs={12} md={9} lg={9}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12} lg={12}>
              <MDBox textAlign="left">
                <InputFileUpload
                  onchangeFile={(file) => {
                    setfileIDpadre(file);
                    setisValid_fileIDpadre(false);
                  }}
                  valueF={fileIDpadre}
                />
                <MDTypography
                  variant="text"
                  color={isValid_fileIDpadre ? "error" : "white"}
                  style={{ opacity: 0.7, fontSize: 14, marginLeft: "2px" }}
                >
                  {isValid_fileIDpadre ? "Archivo bligatorio *" : ""}
                </MDTypography>
              </MDBox>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Divider />
      <Grid container spacing={2}>
        <Grid item xs={12} md={3} lg={3}>
          <MDBox textAlign="right">
            <MDTypography
              variant="h5"
              color={isValid_fileIDmadre ? "error" : "white"}
              style={{ opacity: 0.7, fontSize: "0.9rem" }}
            >
              Identificación oficial de la Madre
            </MDTypography>
          </MDBox>
        </Grid>
        <Grid item xs={12} md={9} lg={9}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12} lg={12}>
              <MDBox textAlign="left">
                <InputFileUpload
                  onchangeFile={(file) => {
                    setfileIDmadre(file);
                    setisValid_fileIDmadre(false);
                  }}
                  valueF={fileIDmadre}
                />
                <MDTypography
                  variant="text"
                  color={isValid_fileIDmadre ? "error" : "white"}
                  style={{ opacity: 0.7, fontSize: 14, marginLeft: "2px" }}
                >
                  {isValid_fileIDmadre ? "Archivo bligatorio *" : ""}
                </MDTypography>
              </MDBox>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Divider />
      <Grid container spacing={2}>
        <Grid item xs={12} md={3} lg={3}>
          <MDBox textAlign="right">
            <MDTypography
              variant="h5"
              color={isValid_fileCartilla ? "error" : "white"}
              style={{ opacity: 0.7, fontSize: "0.9rem" }}
            >
              Cartilla de Vacunación con foto
            </MDTypography>
          </MDBox>
        </Grid>
        <Grid item xs={12} md={9} lg={9}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12} lg={12}>
              <MDBox textAlign="left">
                <InputFileUpload
                  onchangeFile={(file) => {
                    setfileCartilla(file);
                    setisValid_fileCartilla(false);
                  }}
                  valueF={fileCartilla}
                />
                <MDTypography
                  variant="text"
                  color={isValid_fileCartilla ? "error" : "white"}
                  style={{ opacity: 0.7, fontSize: 14, marginLeft: "2px" }}
                >
                  {isValid_fileCartilla ? "Archivo bligatorio *" : ""}
                </MDTypography>
              </MDBox>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Divider />
      <Grid container spacing={2}>
        <Grid item xs={12} md={3} lg={3}>
          <MDBox textAlign="right">
            <MDTypography
              variant="h5"
              color={isValid_fileComprobanteDom ? "error" : "white"}
              style={{ opacity: 0.7, fontSize: "0.9rem" }}
            >
              Comprobante de Domicilio
            </MDTypography>
          </MDBox>
        </Grid>
        <Grid item xs={12} md={9} lg={9}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12} lg={12}>
              <MDBox textAlign="left">
                <InputFileUpload
                  onchangeFile={(file) => {
                    setfileComprobanteDom(file);
                    setisValid_fileComprobanteDom(false);
                  }}
                  valueF={fileComprobanteDom}
                />
                <MDTypography
                  variant="text"
                  color={isValid_fileComprobanteDom ? "error" : "white"}
                  style={{ opacity: 0.7, fontSize: 14, marginLeft: "2px" }}
                >
                  {isValid_fileComprobanteDom ? "Archivo bligatorio *" : ""}
                </MDTypography>
              </MDBox>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Divider />
      {vista === "visualizar" ? null : (
        <MDBox textAlign="right">
          <Button
            variant="contained"
            onClick={() => ValidaForm()}
            sx={{ mt: 1, mr: 1 }}
            size="small"
            color="primary"
          >
            {"Continuar"}
          </Button>
          <Button
            variant="contained"
            disabled={false}
            onClick={() => handleBack()}
            sx={{ mt: 1, mr: 1 }}
            color="secondary"
            size="small"
          >
            Volver
          </Button>
        </MDBox>
      )}
    </>
  );
}

export default DocumentacionAdministrativa;
